import { render, staticRenderFns } from "./SurveyPage.vue?vue&type=template&id=233634ea&scoped=true"
import script from "./SurveyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SurveyPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SurveyPage.vue?vue&type=style&index=0&id=233634ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233634ea",
  null
  
)

export default component.exports